const getBaseV2Url = () => {
  if (window.env && window.env.apiV2Url) {
    return window.env.apiV2Url;
  }
  return "Please configure window.env.apiV2Url!";
};
export default Object.freeze({
  baseV2Url: getBaseV2Url()
})
